import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import TableWarnings from "./TableWarnings";
import {publishEvent} from "core/eventsConnector";

const TabConfirmImport = (props) => {
    const {t: _Tf} = useTranslation("forms");

    const handleAccept = () => {
        let tabs = {...props.statusTabs};
        tabs.validation = false;
        tabs.confirmation = false;
        tabs.result = false;
        props.setStatusTabs(tabs);
        props.setKeyTab("result");
        publishEvent("notifyinventoryacceptimport", props.roomID);
    };

    return (
        <div className="row">
            <div
                className="col-md-10 col-12 m-auto"
                style={{height: "calc(100vh - 130px)"}}>
                <div className="row">
                    <div className="col-md-3 text-center pt-5">
                        <FontAwesomeIcon
                            icon="square-check"
                            className="fa-5x text-muted"
                        />
                        <p className="small mt-md-auto">
                            {_Tf("inventory.title-tab-info-confirm")}
                        </p>
                    </div>
                    <div className="col-md-9 pt-5">
                        <div className="col-12 text-center">
                            <h1>
                                {_Tf("labels.devices")}:{" "}
                                {props.dataVerify.counter.devices} /{" "}
                                {_Tf("labels.containers")}:{" "}
                                {props.dataVerify.counter.actives}
                            </h1>
                        </div>
                        <div className="row mt-5">
                            <div className="col-6 text-center">
                                <h4>{_Tf("labels.news")}</h4>
                                <FontAwesomeIcon
                                    icon="square-check"
                                    className="fa-2x mt-2"
                                />
                                <div className="col-12 d-flex justify-content-center mt-4">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className="text-end text-success border-0">
                                                    <h4>{_Tf("labels.devices")}:</h4>
                                                </td>
                                                <td className="text-end text-success border-0 ps-3">
                                                    <h4>
                                                        {props.dataVerify.news.devices}
                                                    </h4>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="text-end text-success border-0">
                                                    <h4>{_Tf("labels.containers")}:</h4>
                                                </td>
                                                <td className="text-end text-success border-0 ps-3">
                                                    <h4>
                                                        {props.dataVerify.news.actives}
                                                    </h4>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="text-end text-success border-0">
                                                    <h4>{_Tf("routes.routes")}:</h4>
                                                </td>
                                                <td className="text-end text-success border-0 ps-3">
                                                    <h4>{props.dataVerify.routes}</h4>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="text-end text-success border-0">
                                                    <h4>{_Tf("labels.islands")}:</h4>
                                                </td>
                                                <td className="text-end text-success border-0 ps-3">
                                                    <h4>{props.dataVerify.islands}</h4>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="text-end text-success border-0">
                                                    <h4>{_Tf("labels.groups")}:</h4>
                                                </td>
                                                <td className="text-end text-success border-0 ps-3">
                                                    <h4>{props.dataVerify.groups}</h4>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="col-6 text-center">
                                <h4>{_Tf("labels.updated")}</h4>
                                <FontAwesomeIcon icon="edit" className="fa-2x mt-2" />
                                <div className="col-12 d-flex justify-content-center mt-4">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className="text-end text-warning border-0">
                                                    <h4>{_Tf("labels.devices")}</h4>
                                                </td>
                                                <td className="text-end text-warning border-0 ps-3">
                                                    <h4>
                                                        {
                                                            props.dataVerify.updated
                                                                .devices
                                                        }
                                                    </h4>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="text-end text-warning border-0">
                                                    <h4>{_Tf("labels.containers")}</h4>
                                                </td>
                                                <td className="text-end text-warning border-0 ps-3">
                                                    <h4>
                                                        {
                                                            props.dataVerify.updated
                                                                .actives
                                                        }
                                                    </h4>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    {props.warnings.length ? (
                        <TableWarnings items={props.warnings} />
                    ) : (
                        <></>
                    )}
                    <div className="col-12 d-flex justify-content-end mt-4 mb-5">
                        <button
                            className="btn btn-outline-primary"
                            onClick={props.handleBackSelectFile}>
                            {_Tf("labels.back")}
                        </button>
                        <button className="btn btn-primary ms-5" onClick={handleAccept}>
                            {_Tf("labels.accept")}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TabConfirmImport;
